export default __webpack_public_path__ + "static/GSES-logo-rev-6f2402a775bed639a8f953ce57987247.svg";